import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type { ResourceFilters, ResourceSlice } from "./resourcesTypes.ts";

const initialState: ResourceSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "moduleName",
    order: "asc",
  },
};

export const resourcesSlice = createSlice({
  name: "resources",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<ResourceSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<ResourceSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof ResourceFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<ResourceSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  resourcesSlice.actions;

export const selectPage = (state: RootState) => state.resources.page;

export const selectRowsPerPage = (state: RootState) =>
  state.resources.rowsPerPage;

export const selectFilter = (state: RootState) => state.resources.filter;

export const selectSort = (state: RootState) => state.resources.sort;

export default resourcesSlice.reducer;
